import { createFeature, createReducer, on } from '@ngrx/store';
import { actions } from './search-abo.actions';

interface SearchAboState {
    submitFormSuccess: boolean | null;
    submitFormLoading: boolean;
    doiSearchSuccess: boolean | null;
    doiSearchLoading: boolean;
    cancelSearchSuccess: boolean | null;
    cancelSearchLoading: boolean;
}

const initialState: SearchAboState = {
    submitFormSuccess: null,
    submitFormLoading: false,
    doiSearchSuccess: null,
    doiSearchLoading: true,
    cancelSearchSuccess: null,
    cancelSearchLoading: true,
};

export const searchAboState = createFeature({
    name: 'searchAbo',
    reducer: createReducer(
        initialState,
        on(actions.submitSearchAboForm, (state) => {
            return {
                ...state,
                submitFormLoading: true,
            };
        }),
        on(actions.submitSearchAboSuccess, (state) => {
            return {
                ...state,
                submitFormLoading: false,
                submitFormSuccess: true,
            };
        }),
        on(actions.submitSearchAboError, (state) => {
            return {
                ...state,
                submitFormLoading: false,
                submitFormSuccess: false,
            };
        }),
        on(actions.dOISearchAbo, (state) => {
            return {
                ...state,
                doiSearchLoading: true,
            };
        }),
        on(actions.dOISearchAboSuccess, (state) => {
            return {
                ...state,
                doiSearchLoading: false,
                doiSearchSuccess: true,
            };
        }),
        on(actions.dOISearchAboError, (state) => {
            return {
                ...state,
                doiSearchLoading: false,
                doiSearchSuccess: false,
            };
        }),
        on(actions.cancelSearchAbo, (state) => {
            return {
                ...state,
                cancelSearchLoading: true,
            };
        }),
        on(actions.cancelSearchAboSuccess, (state) => {
            return {
                ...state,
                cancelSearchLoading: false,
                cancelSearchSuccess: true,
            };
        }),
        on(actions.cancelSearchAboError, (state) => {
            return {
                ...state,
                cancelSearchLoading: false,
                cancelSearchSuccess: false,
            };
        }),
    ),
});
